/* eslint-disable import/prefer-default-export */
import { SOCIAL_NETWORKS } from 'rebook/apps/base/components/social/constants';


export const SOCIAL_LOGINS = [
  {
    id: 1,
    name: SOCIAL_NETWORKS.FACEBOOK.name,
    icon: SOCIAL_NETWORKS.FACEBOOK.icon,
    slug: 'Facebook',
    url: '/api/cb/social/login/facebook/',
  },
  {
    id: 2,
    name: SOCIAL_NETWORKS.VK.name,
    icon: SOCIAL_NETWORKS.VK.icon,
    slug: 'VK',
    url: '/api/cb/social/login/vkontakte-oauth2/',
  },
  {
    id: 3,
    name: SOCIAL_NETWORKS.GOOGLEPLUS.name,
    icon: SOCIAL_NETWORKS.GOOGLEPLUS.icon,
    slug: 'Googleplus',
    url: '/api/cb/social/login/google-oauth2/',
  },
  {
    id: 4,
    name: SOCIAL_NETWORKS.ODNOKLASSNIKI.name,
    icon: SOCIAL_NETWORKS.ODNOKLASSNIKI.icon,
    slug: 'Odnoklassniki',
    url: '/api/cb/social/login/odnoklassniki/',
  },
  {
    id: 5,
    name: SOCIAL_NETWORKS.TWITTER.name,
    icon: SOCIAL_NETWORKS.TWITTER.icon,
    slug: 'Twitter',
    url: '/api/cb/social/login/twitter/',
  },
  {
    id: 6,
    name: SOCIAL_NETWORKS.LITRES.name,
    icon: SOCIAL_NETWORKS.LITRES.icon,
    slug: 'Litres',
    url: '/api/cb/social/login/litres/',
  },
];
